import React, { FC } from "react";
import { WorksTooltipProps } from "@pages/dashboard/works/components/tooltips/WorksDailyTooltip";
import BaseChartTooltipWithHeader
    , {
    HeaderTypes
} from "@modules/dashboards/dashboardTooltips/TooltipVariants/BaseChartTooltipWithHeader/BaseChartTooltipWithHeader";
import { IPeriod } from '@baseTypes/service/dashboard/IWorksDashboardService';

type WorksSeasonTooltipProps = {
    header?: {} & IPeriod
} & WorksTooltipProps

export const WorksSeasonTooltip: FC<WorksSeasonTooltipProps> = ({
                                                              cropPeriods,
                                                              children,
                                                              container,
                                                              header
                                                          }) => {
    return cropPeriods && cropPeriods.length > 0
        ? <BaseChartTooltipWithHeader
            elements={cropPeriods.map(period => ({
                color: period.color,
                name: period.name,
                dateEnd: period.end,
                dateStart: period.start,
                id: `${period.name}-${period.start}-${period.end}`
            }))}
            tooltipProps={{
                container: container?.current || undefined,
                trigger: 'sticky',
                targetStyle: { width: 'inherit' }
            }}
            content={children}
            header={{
                type: HeaderTypes.works,
                from: header?.from,
                to: header?.to
            }}
            width={250}
        />
        : <>{children}</>
}